import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Brain, Menu, X, Coffee } from "lucide-react";

const NAV = [
  { to: "/ask", label: "Ask" },
  { to: "/library", label: "Library" },
  { to: "/chat", label: "Chat" },
  { to: "/settings", label: "Settings" },
];

const FOOTER_LINKS = [
  { to: "/about", label: "About" },
  { to: "/mission", label: "Mission" },
  { to: "/help", label: "Help / FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/disclaimer", label: "Disclaimer" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
];

export function Layout({ children }) {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#F8FAFC" }}>
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b" style={{ borderColor: "#E2E8F0" }}>
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" data-testid="brand-link" className="flex items-center gap-2.5">
            <span className="grid place-items-center w-9 h-9 rounded-xl" style={{ background: "#2563EB" }}>
              <Brain size={20} color="#fff" />
            </span>
            <span className="text-lg font-black tracking-tight" style={{ color: "#1E293B" }}>Acuman</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => {
              const active = loc.pathname === n.to;
              return (
                <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                  className="px-4 py-2 rounded-xl text-sm font-semibold transition-colors duration-200"
                  style={{ color: active ? "#2563EB" : "#475569", background: active ? "#EFF6FF" : "transparent" }}>
                  {n.label}
                </Link>
              );
            })}
          </nav>

          <button className="md:hidden p-2 rounded-xl" data-testid="menu-toggle"
            onClick={() => setOpen(!open)} style={{ color: "#1E293B" }}>
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        {open && (
          <div className="md:hidden border-t px-5 py-3 bg-white" style={{ borderColor: "#E2E8F0" }}>
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
                className="block px-3 py-2.5 rounded-xl text-sm font-semibold" style={{ color: "#475569" }}>
                {n.label}
              </Link>
            ))}
          </div>
        )}
      </header>

      <main className="flex-1 w-full">{children}</main>

      <footer className="border-t mt-16 bg-white" style={{ borderColor: "#E2E8F0" }}>
        <div className="max-w-6xl mx-auto px-5 py-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-8 h-8 rounded-xl" style={{ background: "#2563EB" }}>
                <Brain size={16} color="#fff" />
              </span>
              <span className="font-bold" style={{ color: "#1E293B" }}>Acuman</span>
            </div>
            <a href="https://buymeacoffee.com/acuman" target="_blank" rel="noreferrer" data-testid="tip-jar-link"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors duration-200"
              style={{ background: "#ECFDF5", color: "#047857" }}>
              <Coffee size={16} /> Tip Jar — Buy me a coffee
            </a>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2 mt-6">
            {FOOTER_LINKS.map((f) => (
              <Link key={f.to} to={f.to} data-testid={`footer-${f.label.toLowerCase().replace(/[^a-z]/g, "")}`}
                className="text-sm transition-colors duration-200 hover:text-[#2563EB]" style={{ color: "#94A3B8" }}>
                {f.label}
              </Link>
            ))}
          </div>
          <p className="text-xs mt-6" style={{ color: "#94A3B8" }}>
            Local-first &amp; private. Your data stays in your browser. © {new Date().getFullYear()} Acuman.
          </p>
        </div>
      </footer>
    </div>
  );
}
